import { render, staticRenderFns } from "./varietyDepth.vue?vue&type=template&id=984d7eb0&scoped=true"
import script from "./varietyDepth.vue?vue&type=script&lang=js"
export * from "./varietyDepth.vue?vue&type=script&lang=js"
import style0 from "./varietyDepth.vue?vue&type=style&index=0&id=984d7eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984d7eb0",
  null
  
)

export default component.exports